<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
           Enroll in PSP
         </h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a routerLink="/driver/1"
             (click)="scrollToTop()"
             name="Driver-record-request"
             id="Driver-record-request"
             [title]="'Start_8-2' | translator:'base'" 
             class="ms-1" 
          >
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar [step]="8" [totalSteps]="19"></app-complete-bar>
               <h2 [innerHTML]="'UserACC_1' | translator:'base'">
                 NEXT, WE'LL COLLECT CONTACT INFORMATION
               </h2>
               <p [innerHTML]="'UserACC_2' | translator:'base'">
                 To set up your account, you'll need to provide a primary contact and a billing contact.
               </p>
               <hr>
               <ul>
                 <li [innerHTML]="'UserACC_3' | translator:'base'">
                   The <strong>primary contact</strong> is the
                   first person we'll reach out to regarding
                   details or changes to your PSP account.
                 </li>
                 <li [innerHTML]="'UserACC_4' | translator:'base'">
                   The <strong>billing contact</strong> will deal
                   with the financial aspects of your account.
                 </li>
                 <li [innerHTML]="'UserACC_5' | translator:'base'">
                   For some companies, the primary and billing
                   contact is the same person.
                 </li>
               </ul>
               <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                 <div class="btn-group" role="group">
                   <a routerLink="/signup/13"
                     (click)="scrollToTop()"
                     class="btn btn-primary btn-strong"
                     [title]="'PrimaryContact' | translator:'base'"
                     name="companyNext12"
                     id="companyNext12"
                  >
                     <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'PrimaryContact' | translator:'base'">Primary Contact</span>
                   </a>
                 </div>
                 <div class="btn-group" role="group">
                   <button [routerLink]="(enrollmentService.newCustomer!.customerType === customerType.AH ? '/signup/11' : '/signup/9')"
                     class="btn btn-outline-primary"
                     [title]="'PSPFees' | translator:'base'"
                     name="companyBack12"
                     id="companyBack12">
                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                     <span class="sr-only" [innerHTML]="'PSPFees' | translator:'base'">PSP Fees</span>
                   </button>
                   <a routerLink="/"
                     tag="button"
                     class="btn btn-light"
                     (click)="scrollToTop()"
                     name="companyCancel12"
                     [title]="'Cancel' | translator:'base'"
                     [innerHTML]="'Cancel' | translator:'base'"
                  >
                     Cancel
                   </a>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="3"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
       </div>
     </div>
   </div>
   
